import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { DeliveryOverviewService } from '../delivery-overview.service';
import { DeliveryMentorDropoutsViewPart } from './dropouts/mentor-dropouts/mentor-dropouts-view.part';
import { DeliveryVentureDropoutsViewPart } from './dropouts/venture-dropouts/venture-dropouts-view.part';
import { DeliveryAllAwardsViewPart } from './graduation/all-awards/all-awards-view.part';
import { DeliveryAllEntrepreneursViewPart } from './people/all-entrepreneurs/all-entrepreneurs-view.part';
import { DeliveryAllMentorsViewPart } from './people/all-mentors/all-mentors-view.part';
import { DeliveryAllVenturesViewPart } from './people/all-ventures/all-ventures-view.part';
import { DeliverySessionFeedbackViewPart } from './surveys/session-feedback/session-feedback-view.part';
import { DeliverySpecialistFeedbackViewPart } from './surveys/specialist-feedback/specialist-feedback-view.part';
import { DeliveryTopicFeedbackViewPart } from './surveys/topic-feedback/topic-feedback-view.part';

@Component({
	selector: 'delivery-overview-views-part',
	standalone: true,
	imports: [
		DroplistWidget,
		// DeliveryOverviewViewPart,
		DeliveryAllVenturesViewPart,
		DeliveryAllEntrepreneursViewPart,
		DeliveryAllMentorsViewPart,
		DeliveryVentureDropoutsViewPart,
		DeliveryMentorDropoutsViewPart,
		DeliverySessionFeedbackViewPart,
		DeliveryTopicFeedbackViewPart,
		DeliverySpecialistFeedbackViewPart,
		DeliveryAllAwardsViewPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './overview-views.part.html',
})
export class DeliveryOverviewViewsPart implements OnInit {
	public service = inject(DeliveryOverviewService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}